import { render } from "./workOrder.vue?vue&type=template&id=064b0300&scoped=true"
import script from "./workOrder.vue?vue&type=script&lang=js"
export * from "./workOrder.vue?vue&type=script&lang=js"

import "./workOrder.vue?vue&type=style&index=0&id=064b0300&scoped=true&lang=css"
import "./workOrder.vue?vue&type=style&index=1&id=064b0300&lang=css"
script.render = render
script.__scopeId = "data-v-064b0300"

export default script